module.exports = __webpack_public_path__ + "img/V-45-ER-550-MI.aa753e68.png";